export default {"src":"https://search.testwiggot.com/_next/static/media/reticle.7c2ff310.svg","height":404,"width":834,"blurWidth":0,"blurHeight":0};